import {
    Component,
    ElementRef,
    ViewEncapsulation,
    ApplicationRef,
    ComponentFactoryResolver,
    Injector,
    Renderer2
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import 'slickgrid/lib/jquery.event.drag-2.3.0';
import 'slickgrid/slick.core';
import 'slickgrid/slick.grid';
import 'slickgrid/slick.editors';
import 'slickgrid/slick.dataview';
import 'slickgrid/plugins/slick.checkboxselectcolumn';
import 'slickgrid/plugins/slick.rowselectionmodel';
import 'slickgrid/plugins/slick.headerbuttons';
import 'slickgrid/plugins/slick.cellexternalcopymanager';
import 'slickgrid/slick.groupitemmetadataprovider';
import 'slickgrid-column-data-autosize/dist/slick.autocolumnsize';
import 'slickgrid/plugins/slick.cellexternalcopymanager';
import {CommonDataService} from "../services/common-data.service";
import {SlickGridComponentBase} from "./slick-grid.component-base";

@Component({
    selector: 'slick-grid',
    template: `
        <div *ngIf="showNoData && hideGrid" class="no-data-grid"><span>{{ translates.NoData }}</span></div>
        <div #grid class="slickgrid" [id]="gridGUID" [class.hide]="showNoData && hideGrid"></div>
        <universal-list *ngIf="showUnList" style="z-index: 110" [GUID]="'123'"
                        [inData]="universalData" [updatePopper]="updatePopper"
                        [wrpRef]="filterBehavior" [addRef]="universalBTN"
                        [settings]="universalSettings" [titleKey]="''"
                        [columns]="unColSettings" [inClass]="filtersCssClass"
                        [customSelect]="customSelect"
                        [sorter]="unListSorter"
                        (hide)="applyFilter($event)"></universal-list>`,
    styleUrls: ['./slick-grid.component.css', './cell-colors.css', '../../../node_modules/slickgrid/slick.grid.css', '../../../node_modules/slickgrid/slick-default-theme.css'],
    encapsulation: ViewEncapsulation.None
})
export class SlickGridComponent extends SlickGridComponentBase{
    constructor(
        appRef: ApplicationRef,
        resolver: ComponentFactoryResolver,
        injector: Injector,
        renderer: Renderer2,
        translateService: TranslateService,
        elementRef: ElementRef,
        commonData: CommonDataService
    ){
        super(appRef, resolver, injector, renderer, translateService, elementRef, commonData)
    }
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/slick-grid.component.ts